import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPytorchLightningLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.25 16.9998L3.25216 6.97188L7.60631 4.48594C10.0011 3.11868 11.9905 2 12.0272 2C12.0639 2 14.0416 3.11832 16.422 4.48517L20.75 6.97034L20.7478 16.9998L17.689 18.748C16.0067 19.7095 14.0394 20.8346 13.3174 21.2481L12.0047 22L3.25 16.9998ZM12.6334 10.8697L13.0792 8.99103C13.3244 7.95778 13.5167 7.08772 13.5066 7.05763C13.4966 7.0275 12.5608 7.92684 11.4273 9.05612L9.36628 11.1093L11.4303 13.0895L10.9857 14.95C10.7412 15.9733 10.5408 16.8531 10.5403 16.905C10.54 16.957 11.4742 16.068 12.6165 14.9295L14.6934 12.8594L12.6334 10.8697Z",
		fill: "#792EE5"
	})
});
export { SvgIconPytorchLightningLogo as ReactComponent };
